import activeFilterList from '../templates/active-filters.hbs';

export default class RecipesPage {
  constructor() {
    // console.info('RecipesPage.constructor()');

    this.state = {
      sliceSize: 4,
      batchStart: 0,
      batchEnd: 0,
      lastChild: null,
      openFilterDrawer: false,
      recipes: null,
      resultCount: null,
      filters: {
        mainIngredient: [],
        fuelType: [],
        mealType: [],
        cookTime: [],
        difficulty: [],
      },
    };

    this.initListeners();
    this.checkURL();
    this.fetchCount();
    this.bannerTile = $('#banner');
  }

  initListeners() {
    // console.info('RecipesPage.initListeners()');

    $('.js-filters-toggle').on('click', (e) => {
      this.toggleFilterBar();
    });

    $('.js-filters-toggle').on('keydown', function (e) {
      var key = e.which;
      if (key == 32 || key == 40 || key == 13) {
        // spacebar, enter, down arrow
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    $('.js-filter-option').on('click', (e) => {
      // console.info('Toggle Filter');

      e.preventDefault();

      const $filterItem = $(e.currentTarget).closest('.filter__item');

      $filterItem.toggleClass('active');
      $filterItem.find('input').prop('checked', $filterItem.hasClass('active'));

      const filterType = $(e.currentTarget).data('filter');
      const filterValue = $filterItem.find('input').val();

      if ($filterItem.hasClass('active')) {
        this.addToFilters(filterType, filterValue);
      } else {
        this.subtractFromFilters(filterType, filterValue);
      }
    });

    $('.js-filter-option').on('keydown', function (e) {
      var key = e.which;
      if (key == 32) {
        // spacebar
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    $('.js-apply-filters').on('click', (e) => {
      e.preventDefault();
      this.renderButtonFilters();
      this.fetchRecipes();
      if ($(window).width() <= 769) {
        this.toggleFilterBar();
      }
    });

    $('.js-apply-filters').on('keydown', function (e) {
      var key = e.which;
      if (key == 32) {
        // spacebar
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    $('.js-clear-filters').on('click', (e) => {
      e.preventDefault();
      this.clearFilters();
    });

    $('.js-clear-filters').on('keydown', function (e) {
      var key = e.which;
      if (key == 32) {
        // spacebar
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    $('.js-drawer-toggle').on('click', (e) => {
      e.preventDefault();
      $(e.currentTarget).parent('.filter').toggleClass('active');
    });

    $('.js-drawer-toggle').on('keydown', function (e) {
      var key = e.which;
      if (key == 32) {
        // spacebar
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    $(window).scroll(() => {
      // console.info(' this.state.lastChild: ',  this.state.lastChild);

      if (
        this.state.lastChild !== null &&
        this.state.lastChild !== undefined &&
        this.elementScrolled('#' + this.state.lastChild)
      ) {
        this.state.lastChild = null;
        this.sliceRecipes();
      }
    });
  }

  toggleFilterBar() {
    $('#filter-bar').toggleClass('active');
    $('#page-recipes').toggleClass('fixed');
  }

  getUrlParameter(sParam) {
    // console.info('RecipesPage.getUrlParameter()');

    // If it is one of the main parts.
    let allowed = {
      ingredients: ['beef', 'pork', 'poultry', 'vegetables', 'seafood', 'other'],
      fuel_type: ['pellets', 'charcoal'],
    };
    let lastPart = window.location.pathname.split('/')[2];
    if (allowed.ingredients.includes(lastPart) || allowed.fuel_type.includes(lastPart)) {
      return lastPart;
    }

    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    let sParameterName;
    let i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        console.log(decodeURIComponent(sParameterName[1]));
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }

  checkURL() {
    // console.info('RecipesPage.checkURL()');

    this.state.openFilterDrawer = false;

    // Check Main Ingredients
    this.checkParams('main_ingredient');

    // Check Fuel Type
    this.checkParams('fuel_type');

    // Check Meal Type
    this.checkParams('meal_type');

    // Check Cook Time
    this.checkParams('cook_time');

    // Check Difficulty
    this.checkParams('difficulty');

    if (this.state.openFilterDrawer === true) {
      $('.js-filters-toggle').click();

      setTimeout(() => {
        this.fetchRecipes();
      }, 500);
    } else {
      this.fetchRecipes();
    }
  }

  checkParams(taxonomy) {
    const params = this.getUrlParameter(taxonomy);
    if (params) {
      const paramsArr = params.split(',');

      $.each(paramsArr, (index, value) => {
        this.checkBox(value);
      });

      //this.state.openFilterDrawer = true;
    }
  }

  checkBox(element) {
    // console.info('RecipesPage.checkBox(' + element + ')');

    const filter = '.js-filter-option--' + element;
    $(filter).click();
  }

  addToFilters(filterType, filterValue) {
    // console.info('RecipesPage.addToFilters()');

    if (filterType == 'main-ingredient') {
      if (!this.state.filters.mainIngredient.includes(filterValue)) {
        this.state.filters.mainIngredient.push(filterValue);
      }
    } else if (filterType == 'fuel-type') {
      if (!this.state.filters.fuelType.includes(filterValue)) {
        this.state.filters.fuelType.push(filterValue);
      }
    } else if (filterType == 'meal-type') {
      if (!this.state.filters.mealType.includes(filterValue)) {
        this.state.filters.mealType.push(filterValue);
      }
    } else if (filterType == 'cook-time') {
      if (!this.state.filters.cookTime.includes(filterValue)) {
        this.state.filters.cookTime.push(filterValue);
      }
    } else if (filterType == 'difficulty') {
      if (!this.state.filters.difficulty.includes(filterValue)) {
        this.state.filters.difficulty.push(filterValue);
      }
    }

    if (!$('.js-apply-filters').is(':visible')) {
      setTimeout(() => {
        this.fetchRecipes();
      }, 500);
    } else {
      $('.js-apply-filters').prop('disabled', false);
      this.fetchCount();
    }
  }

  subtractFromFilters(filterType, filterValue) {
    // console.info('RecipesPage.subtractFromFilters()');

    if (filterType == 'main-ingredient') {
      this.state.filters.mainIngredient = $.grep(this.state.filters.mainIngredient, (value) => {
        return value != filterValue;
      });
    } else if (filterType == 'fuel-type') {
      this.state.filters.fuelType = $.grep(this.state.filters.fuelType, (value) => {
        return value != filterValue;
      });
    } else if (filterType == 'meal-type') {
      this.state.filters.mealType = $.grep(this.state.filters.mealType, (value) => {
        return value != filterValue;
      });
    } else if (filterType == 'cook-time') {
      this.state.filters.cookTime = $.grep(this.state.filters.cookTime, (value) => {
        return value != filterValue;
      });
    } else if (filterType == 'difficulty') {
      this.state.filters.difficulty = $.grep(this.state.filters.difficulty, (value) => {
        return value != filterValue;
      });
    }

    if (!$('.js-apply-filters').is(':visible')) {
      setTimeout(() => {
        this.fetchRecipes();
      }, 500);
    } else {
      $('.js-apply-filters').prop('disabled', false);
      this.renderButtonFilters();
      this.fetchCount();
    }
  }

  renderButtonFilters() {
    // console.info('RecipesPage.renderButtonFilters()');

    // determine active filters
    const $buttonFilters = $('.header__active-filters');

    let activeFilters = [];
    const $filters = $('#filters-form input:checked');

    $filters.each(function () {
      const $this = $(this);
      if ($this.closest('.js-filter-option').hasClass('active')) {
        const value = $this.closest('.js-filter-option').data('value');
        const filter = $this.closest('.js-filter-option').data('filter');
        const name = $this.closest('.js-filter-option').data('display-name');
        activeFilters.push({
          filter: filter,
          slug: value,
          name: name,
        });
      }
    });

    let jqFilter = activeFilters
      .map((x) => {
        return `.js-filter-${x.filter}-${x.slug}`;
      })
      .join(',');
    if (!jqFilter) {
      jqFilter = '*'; // no filters
      $buttonFilters.hide();
    } else {
      $buttonFilters.html(activeFilterList(activeFilters)).addClass('filter-active').show();
    }
  }

  handleButtonFilters() {
    // console.info('RecipesPage.handleButtonFilters()');

    // determine active filters
    const $buttonFilters = $('.header__active-filters');

    // reset filters
    $('.clear-all-filters').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.clearFilters();
    });

    $('.clear-all-filters').on('keydown', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var key = e.which;
      if (key == 32) {
        // spacebar
        e.preventDefault();
        e.stopPropagation();
        $(this).trigger('click');
      }
    });

    // remove a filter
    $('.clear-filter').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      console.info('clear filter');

      const filter = $(e.currentTarget).data('filter');
      $('.js-filter-option--' + filter).click();
      this.fetchRecipes();
    });

    $('.clear-filter').on('keydown', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var key = e.which;
      if (key == 32) {
        // spacebar
        e.preventDefault();
        e.stopPropagation();
        $(this).trigger('click');
      }
    });
  }

  clearFilters() {
    // console.info('RecipesPage.clearFilters()');

    $('input:checkbox').prop('checked', false);

    $('.js-filter-option').removeClass('active');

    this.state.filters.mainIngredient = [];
    this.state.filters.fuelType = [];
    this.state.filters.mealType = [];
    this.state.filters.cookTime = [];
    this.state.filters.difficulty = [];

    $('.js-apply-filters').prop('disabled', false);
    this.renderButtonFilters();
    this.fetchRecipes();
  }

  updateRecipesCount(count) {
    // console.info('RecipesPage.updateRecipesCount()');

    $('#result-count--desktop .count__number').text(count);
    $('#result-count--mobile .count__number').text(count);
  }

  updateFiltersCount() {
    const len = $('#filters-form input:checked').length;

    $('.js-filter-count').text(len);
  }

  updateHeader() {
    // console.info('RecipesPage.updateHeader()');

    const mainIngredient = this.state.filters.mainIngredient[0] ? this.state.filters.mainIngredient[0] : null;
    const fuelType = this.state.filters.fuelType[0] ? this.state.filters.fuelType[0] : null;
    const mealType = this.state.filters.mealType[0] ? this.state.filters.mealType[0] : null;
    const cookTime = this.state.filters.cookTime[0] ? this.state.filters.cookTime[0] : null;
    const difficulty = this.state.filters.difficulty[0] ? this.state.filters.difficulty[0] : null;

    if (mainIngredient) {
      $('.page-hero__content').addClass('hidden');
      $('.js-hero-' + mainIngredient).removeClass('hidden');
    } else if (fuelType) {
      $('.page-hero__content').addClass('hidden');
      $('.js-hero-' + fuelType).removeClass('hidden');
      // } else if (mealType) {
      //   $('.page-hero__content').addClass('hidden');
      //   $('.js-hero-' + mealType).removeClass('hidden');
      // } else if (cookTime) {
      //   $('.page-hero__content').addClass('hidden');
      //   $('.js-hero-' + cookTime).removeClass('hidden');
      // } else if (difficulty) {
      //   $('.page-hero__content').addClass('hidden');
      //   $('.js-hero-' + difficulty).removeClass('hidden');
    } else {
      $('.page-hero__content').addClass('hidden');
      $('.js-hero-default').removeClass('hidden');
    }
  }

  updateURL() {
    // console.info('RecipesPage.updateURL()');

    const fields = {
      main_ingredient: this.state.filters.mainIngredient ? this.state.filters.mainIngredient.join(',') : null,
      fuel_type: this.state.filters.fuelType ? this.state.filters.fuelType.join(',') : null,
      meal_type: this.state.filters.mealType ? this.state.filters.mealType.join(',') : null,
      cook_time: this.state.filters.cookTime ? this.state.filters.cookTime.join(',') : null,
      difficulty: this.state.filters.difficulty ? this.state.filters.difficulty.join(',') : null,
    };

    let location = '/recipes/?';

    $.each(fields, (key, value) => {
      if (value) {
        location += key + '=' + value + '&';
      }
    });

    location = location.slice(0, -1);

    window.history.replaceState(null, null, location);
  }

  async fetchCount() {
    //console.info('count has been fetched');

    const url = '/wp-json/kingsford/v1/recipes/count';

    await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({
        mainIngredient: this.state.filters.mainIngredient,
        fuelType: this.state.filters.fuelType,
        mealType: this.state.filters.mealType,
        cookTime: this.state.filters.cookTime,
        difficulty: this.state.filters.difficulty,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        //console.log('Success:', json);
        this.state.resultCount = json.total;

        this.updateRecipesCount(this.state.resultCount);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  async fetchRecipes() {
    // console.info('RecipesPage.fetchRecipes()');

    const url = '/wp-json/kingsford/v1/recipes/list';

    $('.js-apply-filters').prop('disabled', true);
    this.setGridMessage('Loading...');

    await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({
        mainIngredient: this.state.filters.mainIngredient,
        fuelType: this.state.filters.fuelType,
        mealType: this.state.filters.mealType,
        cookTime: this.state.filters.cookTime,
        difficulty: this.state.filters.difficulty,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        //console.log('Success:', json);
        this.state.recipes = Array.isArray(json)
          ? json.map((recipe) => this.sanitizeRecipe(recipe))
          : [];

        this.render();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  sanitizeRecipe(recipe) {
    const source = recipe && typeof recipe === 'object' ? recipe : {};

    return {
      ...source,
      id: this.sanitizeToken(source.id),
      name: this.sanitizeToken(source.name),
      title: this.sanitizeText(source.title),
      main_ingredient: this.sanitizeToken(source.main_ingredient),
      url: this.sanitizeUrl(source.url, '#'),
      thumbnail: this.sanitizeUrl(source.thumbnail, ''),
    };
  }

  sanitizeText(value) {
    return typeof value === 'string' ? value : '';
  }

  sanitizeToken(value) {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value).replace(/[^a-zA-Z0-9_-]/g, '');
  }

  sanitizeUrl(value, fallback) {
    if (typeof value !== 'string' || value.trim() === '') {
      return fallback;
    }

    try {
      const parsed = new URL(value, window.location.origin);
      const protocol = parsed.protocol.toLowerCase();

      if (protocol !== 'http:' && protocol !== 'https:') {
        return fallback;
      }

      return parsed.href;
    } catch (error) {
      return fallback;
    }
  }

  setGridMessage(message) {
    const gridElement = document.querySelector('.js-box-grid');

    if (!gridElement) {
      return;
    }

    const messageElement = document.createElement('span');
    messageElement.className = 'loader';
    messageElement.textContent = message;

    gridElement.replaceChildren(messageElement);
  }

  createRecipeTileElement(recipe, index) {
    const safeId = this.sanitizeToken(recipe.id);
    const safeName = this.sanitizeToken(recipe.name);
    const safeUrl = this.sanitizeUrl(recipe.url, '#');
    const safeTitle = this.sanitizeText(recipe.title);
    const safeMainIngredient = this.sanitizeToken(recipe.main_ingredient) || 'other';
    const safeThumbnail = this.sanitizeUrl(
      recipe.thumbnail,
      '/wp-content/themes/electro/img/tiles/bk-recipe-tile-default.jpg',
    );

    const $wrapper = $('<div>', {
      id: `recipe-${safeId}`,
      class: 'box_wrapper',
      itemprop: 'itemListElement',
      itemscope: '',
      itemtype: 'http://schema.org/ListItem',
    });

    const $box = $('<div>', {
      id: safeName,
      class: `box box--${safeId}`,
    });

    const $link = $('<a>', {
      href: safeUrl,
      class: `tile-${index} tile__${safeName}`,
      itemprop: 'url',
    });

    const $image = $('<img>', {
      class: 'lazy',
      src: safeThumbnail,
    });

    const $iconUse = $('<use>').attr(
      'xlink:href',
      `/wp-content/themes/electro/inc/svg/defs.svg#icon-${safeMainIngredient}`,
    );

    const $buttonUse = $('<use>').attr(
      'xlink:href',
      '/wp-content/themes/electro/inc/svg/defs.svg#icon-arrow-right',
    );

    const $buttonText = document.createTextNode('Get the recipe ');

    $link[0].appendChild($('<meta>', { itemprop: 'position', content: String(index) })[0]);
    $link[0].appendChild($('<span>', { class: 'box_size' })[0]);
    $link[0].appendChild($('<span>', { class: 'box_overlay' })[0]);

    const $boxImage = $('<div>', { class: 'box_image' });
    const $imageWrapper = $('<div>', { class: 'image__wrapper' });
    $imageWrapper[0].appendChild($image[0]);
    $boxImage[0].appendChild($imageWrapper[0]);

    const $boxContent = $('<div>', { class: 'box_content' });
    const $recipeTop = $('<div>', { class: 'recipe_top clearfix' });
    const $boxIcon = $('<span>', { class: 'box_icon' });
    const $iconSvg = $('<svg>', { class: 'icon', 'aria-hidden': 'true', role: 'img' });
    $iconSvg[0].appendChild($iconUse[0]);
    $boxIcon[0].appendChild($iconSvg[0]);
    $recipeTop[0].appendChild($boxIcon[0]);

    const $title = $('<h2>').text(safeTitle);

    const $rating = $('<div>', {
      class: 'recipe__bv-rating',
      'data-bv-show': 'inline_rating',
      'data-bv-product-id': safeId,
      'data-bv-redirect-url': safeUrl,
    });

    const $button = $('<span>', { class: 'btn-outline white' });
    const $buttonSvg = $('<svg>', { class: 'icon', 'aria-hidden': 'true', role: 'img' });
    $buttonSvg[0].appendChild($buttonUse[0]);
    $button[0].appendChild($buttonText);
    $button[0].appendChild($buttonSvg[0]);

    $boxContent[0].appendChild($recipeTop[0]);
    $boxContent[0].appendChild($title[0]);
    $boxContent[0].appendChild($rating[0]);
    $boxContent[0].appendChild($button[0]);
    $boxImage[0].appendChild($boxContent[0]);
    $link[0].appendChild($boxImage[0]);
    $box[0].appendChild($link[0]);
    $wrapper[0].appendChild($box[0]);

    return $wrapper[0];
  }

  elementScrolled(elem) {
    if (elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top;

      return elemTop <= docViewBottom && elemTop >= docViewTop;
    }
  }

  sliceRecipes() {
    // console.info('RecipesPage.sliceRecipes()');

    this.state.batchEnd = this.state.batchStart + this.state.sliceSize;

    if (this.state.batchEnd >= this.state.recipes.length) {
      this.state.batchEnd = this.state.recipes.length;
    }

    if (this.state.batchEnd <= this.state.recipes.length) {
      const gridElement = document.querySelector('.js-box-grid');

      if (!gridElement) {
        return;
      }

      for (let i = this.state.batchStart; i < this.state.batchEnd; ++i) {
        gridElement.appendChild(this.createRecipeTileElement(this.state.recipes[i], i));
        this.state.batchStart = i + 1;
        // Load banner tile in 4th position in mobile, 8th position in desktop, last if less than 4 in mobile, last if less than 8 in desktop
        if (i == 2 && $(window).width() <= 600) {
          gridElement.appendChild(this.bannerTile[0]);
        } else if (this.state.recipes.length < 4 && $(window).width() <= 600) {
          gridElement.appendChild(this.bannerTile[0]);
        } else if (i == 6 && $(window).width() > 600) {
          gridElement.appendChild(this.bannerTile[0]);
        } else if (this.state.recipes.length < 8 && $(window).width() > 600) {
          gridElement.appendChild(this.bannerTile[0]);
        }
      }

      // console.info('Next batch will start at: ', this.state.batchStart);

      this.state.lastChild = $('.js-box-grid .box_wrapper').last().attr('id');
      // console.info('Last child: ', this.state.lastChild);
    }
  }

  render() {
    this.updateRecipesCount(this.state.recipes.length);
    this.updateFiltersCount();
    this.updateHeader();
    this.renderButtonFilters();
    this.handleButtonFilters();
    this.updateURL();

    $('.js-box-grid').html('');
    ((this.state.batchStart = 0), (this.state.batchEnd = 0), (this.state.lastChild = null));

    if (this.state.recipes.length > 0) {
      this.sliceRecipes();
    } else {
      this.setGridMessage('No recipes were found matching your selection.');
    }

    $('.lazy').lazy({
      effect: 'fadeIn',
      effectTime: 0,
      threshold: 500,
    });
  }
}
